import { useCallback } from 'react';

import { ApiSectionNamespace } from '@api';
import {
  useHttpClientAwaitable,
  GRAPHQL_HEADER,
  httpMethods,
  IGeneralRequestResponse,
  IGraphQlQuery,
  IHttpHookResponseAwaitable,
} from '@services/httpClientService';

import { DELETE_SELECTION_GIFT_MUTATION } from './deleteSelectionGiftMutation';
import { IDeleteGift, IDeleteGiftsResponse, IGiftsDeleteData } from './model';

const mappingFunction = (result: IDeleteGiftsResponse): IGeneralRequestResponse<IGiftsDeleteData> =>
  result.deleteGiftSelection;

export const useDeleteGiftAwaitable = (): IHttpHookResponseAwaitable<
  IGeneralRequestResponse<IGiftsDeleteData>,
  IDeleteGift
> => {
  const { request: awaitableRequest } = useHttpClientAwaitable<
    IGeneralRequestResponse<IGiftsDeleteData>,
    IGraphQlQuery,
    IDeleteGiftsResponse
  >({
    method: httpMethods.DELETE,
    path: ApiSectionNamespace.ECartApiKeys.CART_GIFTS_SELECTED_DELETE_URL,
    mappingFunction,
    customHeaders: GRAPHQL_HEADER,
  });

  const request = useCallback(
    (data?: IDeleteGift) => {
      const payload = { query: DELETE_SELECTION_GIFT_MUTATION };
      return awaitableRequest({
        data: payload,
        ...(data && { restUrlParams: [{ name: 'itemId', value: data.itemId.toString() }] }),
      });
    },
    [awaitableRequest],
  );

  return { request };
};
